// StudentProfileLogoutIcon.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';

const StudentProfileLogoutIcon = ({ className = '', showRole = true }) => {
  const [studentProfile, setStudentProfile] = useState({ name: "", studentId: "" });
  const navigate = useNavigate();

  useEffect(() => {
    // Read student data from localStorage
    const storedStudent = localStorage.getItem('studentData');
    if (storedStudent) {
      try {
        const parsed = JSON.parse(storedStudent);
        setStudentProfile({
          name: parsed.name || "Student",
          studentId: "Student"
        });
      } catch (error) {
        console.error("Error parsing student profile:", error);
        setStudentProfile({ name: "Student", studentId: "N/A" });
      }
    } else {
      setStudentProfile({ name: "Student", studentId: "N/A" });
    }
  }, []);

  const handleLogout = () => {
    // Clear student data from localStorage
    localStorage.removeItem("studentData");
    localStorage.removeItem("token"); // if token is used
    navigate("/", { replace: true });
  };

  return (
    <div
      className={`student-profile-icon ${className}`}
      style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
    >
      {showRole && (
        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
          <span style={{ fontWeight: 600 }}>{studentProfile.name}</span>
          <span style={{ fontSize: '12px', color: '#555' }}>{studentProfile.studentId}</span>
        </div>
      )}

      <LogOut
        size={20}
        style={{ cursor: 'pointer', color: '#e53935' }}
        onClick={handleLogout}
        title="Logout"
      />
    </div>
  );
};

export default StudentProfileLogoutIcon;
